import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { ForceUpdateService } from '@app/core/guards/force-profile-update/force-update.service';
import { FORCE_PROFILE_UPDATE_PATH } from '@app/+profile-form/profile-routes';
import { PROFILE_ROUTE_PATH } from '@app/consts';
import { BaseParamsService } from '@app/core/base-params.service';


@Injectable()
export class ForcedProfileUpdateGuard implements CanActivate {
  private router = inject(Router);
  private service = inject(ForceUpdateService);
  private baseParamsService = inject(BaseParamsService);


  public canActivate(): Observable<UrlTree | boolean> {
    return combineLatest([
      this.service.requireForceConsentUpdate$(),
      this.service.requireForcePropertiesUpdate$(),
    ]).pipe(
      take(1),
      map(([requireConsentUpdate, requirePropertiesUpdate]) => {
          if (requireConsentUpdate || requirePropertiesUpdate) {
            const url = this.getForcedUpdateUrl();
            return this.router.createUrlTree(url, {
              queryParams: {
                consents: requireConsentUpdate,
                properties: requirePropertiesUpdate,
              },
            });
          } else {
            return true;
          }
        },
      ));
  }

  private getForcedUpdateUrl = (): (string | Record<string, string>)[] => {
    return [
      ...this.baseParamsService.getRootURIUrlCommands(),
      PROFILE_ROUTE_PATH,
      FORCE_PROFILE_UPDATE_PATH,
    ];
  };
}
